import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MONTHS, DEMO_HEX } from "@/lib/services";
import { whatsappLink } from "@/lib/billing";

const PATTERN = [["poco", "contrato"], ["bebedouro", "contrato"], ["caixa"], ["contrato", "bebedouro"], ["contrato"], ["bebedouro", "caixa"],
  ["contrato"], ["bebedouro", "poco"], ["caixa", "contrato"], ["bebedouro"], ["contrato", "caixa"], ["bebedouro", "contrato"]];

const YearMock = () => (
  <div className="grid grid-cols-3 gap-2.5 rounded-2xl border border-slate-700/60 bg-slate-900/80 p-4 shadow-2xl sm:grid-cols-4" aria-hidden="true">
    {MONTHS.map((m, i) => (
      <div key={m} className={`rise rounded-lg border p-2.5 ${i === 9 ? "border-slate-200" : "border-slate-700/60"} bg-slate-800/70`} style={{ animationDelay: `${i * 45}ms` }}>
        <div className="text-[10px] font-bold uppercase tracking-wider text-slate-400">{m.slice(0, 3)}</div>
        <div className="mt-2 space-y-1">
          {PATTERN[i].map((t, j) => (
            <div key={t} className="h-1.5 rounded-full" style={{ background: DEMO_HEX[t], width: `${50 + ((i + j) * 13) % 45}%` }} />
          ))}
        </div>
      </div>
    ))}
  </div>
);

export const Hero = ({ info }) => (
  <section id="topo" className="mx-auto grid max-w-6xl items-center gap-12 px-4 pb-20 pt-16 sm:px-6 lg:grid-cols-2 lg:pt-24">
    <div className="rise">
      <span className="rounded-full border border-slate-700 px-3 py-1 text-xs font-medium text-slate-300">Para empresas com clientes recorrentes</span>
      <h1 className="mt-6 font-display text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl" data-testid="landing-title">
        Transforme os retornos dos seus clientes em novos agendamentos.
      </h1>
      <p className="mt-6 max-w-xl text-base text-slate-300 md:text-lg">
        Clínicas, oficinas, empresas de higienização e qualquer serviço que se repete. Você define a periodicidade, o Ciclo Certo calcula o próximo retorno e avisa a hora certa de chamar o cliente.
      </p>
      <div className="mt-8 flex flex-wrap gap-3">
        <Button asChild className="h-12 rounded-full px-6 font-semibold" data-testid="hero-cta-button">
          <Link to="/cadastro">Testar grátis por 7 dias <ArrowRight className="ml-2 h-4 w-4" /></Link>
        </Button>
        {info?.whatsapp && (
          <Button asChild variant="outline" className="h-12 rounded-full border-[#25D366]/60 bg-transparent px-6 text-[#25D366] hover:bg-[#25D366]/10" data-testid="hero-whatsapp-button">
            <a href={whatsappLink(info.whatsapp, "Olá! Quero conhecer o Ciclo Certo.")} target="_blank" rel="noreferrer"><MessageCircle className="mr-2 h-4 w-4" /> Falar no WhatsApp</a>
          </Button>
        )}
      </div>
      {info && <p className="mt-4 text-sm text-slate-400">{info.trial_days} dias grátis para testar.</p>}
    </div>
    <YearMock />
  </section>
);
